var map = {
	"./cartotrade-logo.png": "8c24",
	"./cazana-logo.png": "9c04",
	"./cazoo-logo.png": "c4ac",
	"./motorcheck-logo.png": "a62f",
	"./motors-logo.png": "7f46",
	"./percayso-logo.png": "4436"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7a96";